import { hardRedirect } from '@/core/navigation/redirect.service';
import { router } from '@/core/router';
import { QueryKeys } from '@/shared/config/route-query.config';

export interface TabShifterWindow extends Window {
    extensionCallback: null | (() => void);
}

const tabShifterWindow = window as unknown as TabShifterWindow;

const tabShifterCallback = (): void => {
    const domElem = document.getElementById('webShopData');
    if (domElem !== null) {
        const parsed = JSON.parse(domElem.innerText);
        if (parsed.url) {
            window.location.replace(parsed.url);
        }
    }
};

tabShifterWindow.extensionCallback = tabShifterCallback;

export function usePosPayment() {
    const launch = (url: string, extensionId?: string): void => {
        const isExtensionCommunicationEnabled = chrome?.runtime?.sendMessage !== undefined;
        const isFeatureEnabled = extensionId !== undefined;
        if (isExtensionCommunicationEnabled && isFeatureEnabled) {
            tryLaunchByTabShifter(url, extensionId);
        } else {
            launchByRedirect(url);
        }
    };

    const launchByRedirect = (url: string): void => {
        hardRedirect(url);
    };

    const tryLaunchByTabShifter = async(url: string, id: string): Promise<void> => {
        const path = router.currentRoute.value.path;
        const query = {
            ...router.currentRoute.value.query,
            [QueryKeys.GotoPOS]: 1,
        };
        await router.replace({ path, query });
        chrome.runtime.sendMessage(id, { siteId: 2, url: url }, (success) => {
            if (success === undefined) {
                launchByRedirect(url);
            } else if (!success) {
                window.open(url);
            }
        });
    };

    return {
        launch,
    };
}
